'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Element = {};

exports.__exports = Element;
